import { render, staticRenderFns } from "./ConfirmEmailView.vue?vue&type=template&id=c264fc90"
import script from "./ConfirmEmailView.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailView.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmEmailView.vue?vue&type=style&index=0&id=c264fc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports